import * as React from 'react'
import type { SVGProps } from 'react'
const SvgBlockQuote = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 44 32"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M-447-1795h1640v5069H-447z" />
    <path
      fill="currentColor"
      d="M0 32V19.986q0-8.54 4.043-13.495 4.1-4.953 11.9-6.491v5.922q-5.808 1.821-7.8 6.263a10.15 10.15 0 0 0-.855 4.84h8.94V32zM42.932 5.922q-5.751 1.764-7.743 6.377-1.14 2.448-.911 4.726h8.94V32H26.988V19.986q0-8.655 4.157-13.552Q35.36 1.537 42.932 0z"
    />
  </svg>
)
export default SvgBlockQuote
